<template>
    <div>
        <veui-dialog
            title=""
            :open.sync="lawChargeDialogShow"
            overlay-class="law-charge-dialog"
            :before-close="beforeClose"
        >
            <iframe
                v-if="agreementInfo.url"
                :src="agreementInfo.url"
                class="law-charge-dialog-content"
            ></iframe>
            <veui-form
                ref="form"
                :data="formData"
                class="bind-phone-form"
            >
                <veui-field
                    name="isAgree"
                    label=""
                    :rules="[{name: 'required', value: true, message: '请先阅读并同意相关协议', trigger: 'change'}]"
                >
                    <veui-checkbox
                        v-model="formData.isAgree"
                        :false-value="null"
                    >
                        我已阅读并同意
                    </veui-checkbox>
                    《{{ agreementInfo.name }}》
                </veui-field>
            </veui-form>
            <template #foot>
                <veui-button
                    ui="primary"
                    @click="lawCharge('ok')"
                >
                    充值
                </veui-button>
                <veui-button
                    ui="strong"
                    @click="lawCharge('cancel')"
                >
                    取消
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file lawChargeDialog
 * @author sunxiaofeng01
 * @desc 充值协议弹窗
 */
import {Dialog, Button, Form, Checkbox, Field} from 'veui';
import {isBoolean} from 'lodash';
import {mapActions} from 'vuex';
import bendSDK from '@baidu/bend-plugin-sdk';
const url = {
    getChargeUrl: '/bp/api/mid/law_recharge'
};

export default {
    name: 'law-charge-dialog',
    props: {
        show: {
            'type': Boolean,
            'default': false
        }
    },
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-checkbox': Checkbox,
        'veui-form': Form,
        'veui-field': Field
    },
    data() {
        return {
            lawChargeDialogShow: false,
            formData: {
                isAgree: null
            },
            agreementInfo: {},
            chargeUrl: {}
        };
    },
    watch: {
        show(next, pre) {
            this.lawChargeDialogShow = next;
        }
    },
    created() {
        this.getagreement();
    },
    methods: {
        ...mapActions({
            getLawAgreement: 'lawStore/getLawAgreement'
        }),
        beforeClose(type) {
            this.$emit('update:show', false);
            if (type === 'ok') {
                window.open(this.chargeUrl);
            }
        },
        getagreement() {
            this.getLawAgreement().then(data => {
                if (data) {
                    this.agreementInfo = data[0];
                    this.getChargeUrl(data[0]);
                }
            }).catch(err => this.$normalizeResponseError(err));
        },
        getChargeUrl(json) {
            const data = {
                account_id: window?.merchants_id,
                capital_type: 1,
                agreement_ids: json.id,
                agreement_data: JSON.stringify({agreement_ids: json.id})
            };
            this.$http.post(url.getChargeUrl, {
                ...data,
                params: JSON.stringify(data)
            }).then(resp => {
                const data = this.$normalizeResponseData(resp);
                if (data) {
                    this.chargeUrl = data.rechargeUrl;
                }
            }).catch(err => this.$normalizeResponseError(err));
        },
        lawCharge(type) {
            if (type === 'ok') {
                this.$refs.form.validate().then(flag => {
                    if (isBoolean(flag) && flag) {
                        window.location.href = this.chargeUrl;
                    }
                    else {
                        let toast = {
                            content: '请完成必填选项',
                            duration: 1
                        };
                        this.$Message.info(toast);
                    }
                });
            }
            else {
                this.beforeClose(type);
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.law-charge-dialog
    /deep/ .veui-dialog-content
        width 800px
        .veui-dialog-content-foot
            padding-top 24px
        .veui-dialog-content-body
            font-family PingFangSC-Regular
            font-size 14px
            color #282C33
            letter-spacing 0
            line-height 25px
    .law-charge-dialog-content
        width 100%
        min-height 500px
    .rule
        color #0052CC
        display inline-block
    /deep/ .veui-field-no-label
        margin-left 0
</style>
